<template>
	<transition name="fade" mode="out-in" appear>
		<router-view :keep-alive="true"></router-view>
	</transition>
</template>

<script>
    export default {
        name: "manager",
        data(){
          return {
              productType:'App\\Product',
              productId:0,
          }
        },
        /*beforeRouteEnter(to, from, next){
            next(vm =>{
               vm.$store.dispatch('resetOrder');
            });
        },*/
		created(){
            this.$store.dispatch('resetOrder');

            this.productType = this.$route.params.type === 'CustomProduct' ? 'App\\CustomProduct':'App\\Product';
            this.productId = this.$route.params.id;

            this.$store.dispatch('setProductType', this.productType);

			this.$store.dispatch('getProduct', this.productId);
			this.$store.dispatch('getPackagingFee');
            this.$store.dispatch('getEnergyFee');
			this.$store.dispatch('getDeliveryZipCodes');



           /* if(this.$route.path === '/' && this.productType === 'App\\Product')
            {
                return;
            }*/

			this.$router.replace({
                name: this.productType === 'App\\Product' ? 'make-order.product':'make-order.custom.product',
            }).catch(()=>{

            })
		}
    }
</script>
